// @flow

import * as React from 'react';
import ModalWithSubmitActions from './modal_with_submit_actions';
import useModal from './use_modal';
import Typography from '../typography';

export type ConfirmModalProps = {
  title: string,
  onConfirm: Function,
  confirmText?: string,
  children?: React.Element<any>,
  modalContent?: React.Element<any>,
  fullWidth?: boolean,
  hideCancelButton?: boolean,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  submitText?: string,
  cancelText?: string,
  modalBodyOverflow?: string,
};

const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    children,
    confirmText,
    onConfirm,
    modalContent,
    title,
    fullWidth,
    maxWidth,
    submitText,
    cancelText,
    hideCancelButton,
    modalBodyOverflow,
  } = props;
  const [open, openModal, closeModal] = useModal(false);

  function confirm() {
    onConfirm();
    closeModal();
  }

  return (
    <React.Fragment>
      {children &&
        React.cloneElement(children, {
          onClick: openModal,
        })}

      <ModalWithSubmitActions
        open={open}
        closeModal={closeModal}
        onSubmit={confirm}
        title={title}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        dividers={false}
        submitText={submitText}
        cancelText={cancelText}
        hideCancelButton={hideCancelButton}
        draggable={false}
        modalBodyOverflow={modalBodyOverflow}
        fancy
      >
        {confirmText ? (
          <Typography type="p">{confirmText}</Typography>
        ) : (
          modalContent
        )}
      </ModalWithSubmitActions>
    </React.Fragment>
  );
};

export default ConfirmModal;

ConfirmModal.defaultProps = {
  open: false,
  fullScreen: false,
  fullWidth: true,
  maxWidth: 'sm',
  displayXIcon: true,
};
